
document.addEventListener('DOMContentLoaded', () => {
  const deliveryOptions = document.querySelector('.delivery-options');
  deliveryOptions.style.display = 'none';

  const deliveryDateInput = document.getElementById("delivery-date");
  const deliveryTimeSelect = document.getElementById("delivery-time");
  const cfg = window.DeliveryConfig;

  const yamatoAppDescription = document.querySelector(".check_time-description > span");

  // 休業日を week index に変換（flatpickr 用）
  const weekdayMap = {
    'Sunday': 0,
    'Monday': 1,
    'Tuesday': 2,
    'Wednesday': 3,
    'Thursday': 4,
    'Friday': 5,
    'Saturday': 6
  };
  const holidayIndexes = cfg.holidays.map(d => weekdayMap[d]);

  // 今日の日付基準で、締め時刻を考慮して「起算日」を決定
  function getBaseDate() {
    const now = new Date();
    const [hh, mm] = cfg.cutoffTime.split(':').map(n => parseInt(n));
    const cutoff = new Date();
    cutoff.setHours(hh, mm, 0, 0);

    const base = new Date();
    if (now > cutoff) {
      base.setDate(base.getDate() + 1); // 翌日扱い
    }
    return base;
  }

  // 倉庫休業日（出荷不可）をスキップして offsetMin 日後の「最短配送日」を算出
  function addBusinessDays(baseDate, daysNeeded) {
    const date = new Date(baseDate);
    let added = 0;

    while (added < daysNeeded) {
      date.setDate(date.getDate() + 1);
      const dow = date.getDay();

      if (!holidayIndexes.includes(dow)) {
        added++;
      }
    }
    return date;
  }

  // flatpickr の disable ロジック
  function disableDates(date) {
    // 曜日が休業日なら除外
    return holidayIndexes.includes(date.getDay());
  }

  function updateCalendar(baseDate,minDate=null,maxDate=null) {
    // 日付カレンダー生成
    if(!minDate){
        minDate = addBusinessDays(baseDate, cfg.offsetMin);
    }
    if(!maxDate){
        maxDate = addBusinessDays(baseDate, cfg.offsetMax);
    }
    
    // 既にflatpickrが存在する場合は設定だけ更新
    if (deliveryDateInput._flatpickr) {
      deliveryDateInput._flatpickr.set('minDate', minDate);
      deliveryDateInput._flatpickr.set('maxDate', maxDate);
      deliveryDateInput._flatpickr.set('disable', [disableDates]);
      return;
    }

    flatpickr("#delivery-date", {
        dateFormat: 'Y-m-d',
        minDate: minDate,
        maxDate: maxDate,
        disable: [disableDates]
    });
  }

  async function saveAttributes() {
    const urlencoded = new URLSearchParams();
    urlencoded.append("attributes[delivery_date]", deliveryDateInput.value || "");
    urlencoded.append("attributes[delivery_time]", deliveryTimeSelect.value || "");
    await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        credentials: "include",
        body: urlencoded
    });
  }

  deliveryDateInput.addEventListener("change", saveAttributes);
  deliveryTimeSelect.addEventListener("change", saveAttributes);

  updateCalendar(getBaseDate());

  // ■ 時間帯セレクトの生成
  const timeSelect = document.querySelector('#delivery-time');
  // ヤマト向け時間帯対応マッピング
  const timeValueMap = {
  '午前中': '0812',
  '14:00-16:00': '1416',
  '16:00-18:00': '1618',
  '18:00-20:00': '1820',
  '19:00-21:00': '1921',
};

  cfg.timeRanges.forEach(slot => {
    const op = document.createElement('option');
    op.value = timeValueMap[slot] ?? slot;
    op.textContent = slot;
    timeSelect.appendChild(op);
  });

  const checkbox = document.querySelector('input#checkbox1');
  
  let lastValue = checkbox.checked;
  let fastestDate = document.querySelector('.estimated_delivery_time');

  const resetDeliveryOptions = () => {
    const dateInput = deliveryOptions.querySelector('#delivery-date');
    const timeSelect = deliveryOptions.querySelector('#delivery-time');

    // flatpickr 側の選択値もクリア
    if (dateInput?._flatpickr) {
      dateInput._flatpickr.clear(false);
    } else if (dateInput) {
      dateInput.value = '';
    }
    if (timeSelect) {
      timeSelect.value = '';
    }
    // Shopify cart.attributes 側もクリア
    // Shopify側の属性削除は非同期で実行
    saveAttributes().catch(console.error);
  };

  if (!checkbox || !deliveryOptions) return;
  const updateVisibility = () => {
    // ヤマト未取得なら常に非表示
    if (fastestDate.innerHTML === " - ") {
      deliveryOptions.style.display = 'none';
      return;
    }

    if (checkbox.checked) {
      deliveryOptions.style.display = 'none';
    } else {
      deliveryOptions.style.display = '';
    }
  };

  updateVisibility();

  // チェックが ON/OFF されたら反映
  checkbox.addEventListener('change', () => {
    if (checkbox.checked) {
      // 「最短希望」に戻したら日時指定をクリア
      resetDeliveryOptions();
    }
    updateVisibility();
  });

  const observer = new MutationObserver(() => {
    if (checkbox.checked !== lastValue) {
      lastValue = checkbox.checked;
      checkbox.dispatchEvent(new Event('change'));
    }
  });

  
  
  // 属性の変化を監視
  observer.observe(checkbox, {
    attributes: true,
    attributeFilter: ['checked','disabled']
  });


  const observer2 = new MutationObserver(() => {
    if (fastestDate.innerHTML !== " - ") {
      yamatoAppDescription.style.display = 'none';

      if(!checkbox){
        // 👇 追加：delivery-options を表示
        deliveryOptions.style.display = '';
      }

        const fastestDateTxt = fastestDate.innerHTML
        const [year, month, day] = fastestDateTxt.match(/\d+/g).map(Number);
        const date = new Date(year, month - 1, day);// JS の month は 0 始まり
        updateCalendar(getBaseDate(),date.setDate(date.getDate() +1),date.setDate(date.getDate() + cfg.offsetMax - cfg.offsetMin));
    }
  });

  
  observer2.observe(fastestDate, {
    characterData: true,
    attributeFilter: ['style']
  });
  
});